import React from "react";
import { FloatButton, Spin, Button } from "antd";
import {
  PlusOutlined,
  PauseOutlined,
  CaretRightOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  setShowProbabilities,
  getShowProbabilities,
  setUseSetStates,
  getUseSetStates,
  setDeleteMode,
  getDeleteMode,
} from "./UserSettings";
import { setRefreshNodes } from "./App";
import { nodesExt, edgesExt, anyEvidence } from "./Flow.js";

import "../css/float-controls.css";

/*
Floating controls on the top left of the network
*/

function FloatControls({ addNode, forceUpdateFlow }) {
  let anyEvidenceSet = anyEvidence(nodesExt);

  return (
    <div className="float-controls">
      <Button
        type="primary"
        shape="circle"
        size="large"
        icon={
          <PlusOutlined style={{ fontSize: "1.35em", paddingTop: "0.07em" }} />
        }
        onClick={() => {
          addNode();
        }}
      />

      <Button
        type="primary"
        shape="circle"
        danger={getDeleteMode()}
        size="large"
        icon={
          <DeleteOutlined
            style={{ fontSize: "1.35em", paddingTop: "0.07em" }}
          />
        }
        onClick={() => {
          setDeleteMode(!getDeleteMode());
          forceUpdateFlow();
          setRefreshNodes();
        }}
      />

      <Button
        type="primary"
        shape="circle"
        size="large"
        icon={
          getShowProbabilities() ? (
            <PauseOutlined
              style={{ fontSize: "1.35em", paddingTop: "0.07em" }}
            />
          ) : (
            <CaretRightOutlined
              style={{ fontSize: "1.35em", paddingTop: "0.07em" }}
            />
          )
        }
        onClick={() => {
          setShowProbabilities(!getShowProbabilities());
          forceUpdateFlow();
          setRefreshNodes();
        }}
      />

      {anyEvidenceSet && (
        <Button
          type="primary"
          shape="circle"
          size="large"
          icon={
            getUseSetStates() ? (
              <EyeOutlined
                style={{ fontSize: "1.3em", paddingTop: "0.07em" }}
              />
            ) : (
              <EyeInvisibleOutlined
                style={{ fontSize: "1.3em", paddingTop: "0.07em" }}
              />
            )
          }
          onClick={() => {
            setUseSetStates(!getUseSetStates());
            forceUpdateFlow();
            setRefreshNodes();
          }}
        />
      )}
    </div>
  );
}

export default FloatControls;
